{
  "shell": {
    "menu": {
      "label": "Menu du compte",
      "close": "Fermer le menu",
      "profile": "Profil",
      "signInSecurity": "Connexion et sécurité",
      "settings": "Paramètres",
      "logOut": "Se déconnecter"
    },
    "avatar": {
      "label": "Compte"
    },
    "settings": {
      "title": "Paramètres",
      "appearance": "Apparence",
      "theme": "Thème",
      "themeSystem": "Système",
      "themeLight": "Clair",
      "themeDark": "Sombre",
      "language": "Langue",
      "appLanguage": "Langue de l’application"
    },
    "back": "Retour"
  }
}
